<template>
  <div
    class="card-card"
    :class="{
      disabled: disabled,
    }"
    @click="goToDetail"
  >
    <div class="card-card-header mb-16">
      <div class="card-card-header-left mr-24">
        <img
          class="card-card-icon"
          :src="providerLogo"
        >
      </div>
      <div class="card-card-header-right">
        <div class="card-card-name mb-8">{{
          `${value.providerCompanyName || ""}${value.goodsType}`
        }}</div>
        <div class="card-card-value">
          面额：{{ value.couponAmountYuan || 0 }}元
        </div>
      </div>
    </div>
    <div class="card-card-content">
      <img
        v-if="disabled && icons[value.unAvailReason]"
        class="card-content-icon"
        :src="icons[value.unAvailReason] || ''"
      >
      <div class="card-card-balance-text">可用余额</div>
      <div class="card-card-balance">{{ value.freeAmtYuan || 0 }}</div>
      <div
        class="flex-end-between"
        style="height: 30px;"
      >
        <div class="card-card-date">
          过期时间：{{ value.endTime || "" }}
        </div>
        <div
          v-if="!disabled"
          class="use-btn flex-center-center"
          @click.stop="handleToUseClick"
        >
          去使用
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cardMixin from '../mixins/cardMixin.js';
import IconRightUsed from '@/assets/img/chargingVoucher/icon-right-used.png';
import IconRightExpired from '@/assets/img/chargingVoucher/icon-right-expire.png';

export default {
  name: 'CardCard',
  mixins: [cardMixin],
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icons: {
        已用完: IconRightUsed,
        已过期: IconRightExpired
      },
      isCard: true
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.card-card {
  background: #ffffff;
  background-image: linear-gradient(180deg, #ff722c 1%, #ffbf9f 99%);
  border-radius: 20px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 16px;
  padding: 16px 12px 12px 12px;

  &.disabled {
    filter: grayscale(100%);
  }
  .card-card-header {
    display: flex;
    align-items: flex-start;

    .card-card-header-left {
      .card-card-icon {
        width: 64px;
        height: 64px;
        object-fit: contain;
      }
    }
    .card-card-header-right {
      .card-card-name {
        font-size: 32px;
        color: #ffffff;
        font-weight: bold;
        line-height: 45px;
      }
      .card-card-value {
        font-size: 24px;
        color: #ffffff;
        text-align: right;
        font-weight: 400;
        line-height: 33px;
        text-align: left;
      }
    }
  }
  .card-card-content {
    background: #ffffff;
    border-radius: 20px;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .card-content-icon {
      width: 116px;
      height: 116px;
      position: absolute;
      right: 32px;
      object-fit: contain;
    }
    .card-card-balance-text {
      font-size: 24px;
      color: #787878;
      font-weight: 400;
      line-height: 33px;
    }
    .card-card-balance {
      font-size: 48px;
      color: #fe7256;
      font-weight: bold;
      margin-top: 10px;
    }
    .card-card-date {
      font-size: 24px;
      color: #999999;
      text-align: right;
      font-weight: 400;
      line-height: 33px;
      white-space: nowrap;
    }
    .use-btn {
      background: #ff722c;
      border: 1px solid rgba(252, 104, 29, 1);
      border-radius: 28px;
      font-size: 32px;
      color: #ffffff;
      letter-spacing: 0.48px;
      text-align: center;
      font-weight: 400;
      padding: 10px 30px;
      box-sizing: border-box;
    }
  }
}
.mb-8 {
  margin-bottom: 8px;
}
.mb-16 {
  margin-bottom: 16px;
}
.mr-24 {
  margin-right: 24px;
}
.flex-end-between {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
